import React, { useEffect, useState } from 'react';
import { instagramService } from '../../services/instagramService';
import AdminLayout from '../../components/AdminLayout';

const AdminInstagram = () => {
    const [instagramStatus, setInstagramStatus] = useState(null);
    const [accessToken, setAccessToken] = useState('');
    const [loading, setLoading] = useState(false);
    const [syncing, setSyncing] = useState(false);

    useEffect(() => {
        loadInstagramStatus();
    }, []);

    const loadInstagramStatus = async () => {
        try {
            const data = await instagramService.getStatus();
            setInstagramStatus(data);
        } catch (err) {
            console.error('Error loading Instagram status:', err);
        }
    };

    const handleLinkInstagram = async () => {
        if (!accessToken.trim()) {
            alert('Please enter an access token');
            return;
        }
        
        try {
            setLoading(true);
            await instagramService.linkAccount(accessToken);
            alert('Instagram account linked successfully!');
            loadInstagramStatus();
            setAccessToken('');
        } catch (err) {
            console.error('Error linking Instagram:', err);
            alert('Error linking Instagram. Please check your access token.');
        } finally {
            setLoading(false);
        }
    };

    const handleSyncInstagram = async () => {
        try {
            setSyncing(true);
            await instagramService.syncPosts();
            alert('Instagram posts synced successfully!');
            loadInstagramStatus();
        } catch (err) {
            console.error('Error syncing Instagram:', err);
            alert('Error syncing Instagram posts.');
        } finally {
            setSyncing(false);
        }
    };

    return (
        <AdminLayout>
            <div>
                {/* Header Section */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '40px'
                }}>
                    <div>
                        <h1 style={{
                            fontSize: '32px',
                            fontWeight: '300',
                            color: 'var(--text-light)',
                            marginBottom: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                        }}>
                            <span style={{ fontSize: '36px' }}>📸</span>
                            Instagram Integration
                        </h1>
                        <p style={{
                            fontSize: '14px',
                            color: 'rgba(245, 241, 237, 0.6)'
                        }}>
                            Connect and sync your Instagram posts to display on your website
                        </p>
                    </div>
                </div>

                {/* Status Card */}
                {instagramStatus && instagramStatus.linked ? (
                    <div style={{
                        background: 'linear-gradient(135deg, rgba(201, 169, 110, 0.08) 0%, rgba(201, 169, 110, 0.03) 100%)',
                        border: '1px solid rgba(201, 169, 110, 0.2)',
                        borderRadius: '16px',
                        padding: '40px',
                        marginBottom: '30px'
                    }}>
                        {/* Connected Status */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            marginBottom: '30px',
                            padding: '20px',
                            background: 'rgba(40, 167, 69, 0.1)',
                            border: '1px solid rgba(40, 167, 69, 0.3)',
                            borderRadius: '12px'
                        }}>
                            <div style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #833AB4 0%, #FD1D1D 50%, #FCAF45 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '24px'
                            }}>
                                ✓
                            </div>
                            <div style={{ flex: 1 }}>
                                <div style={{
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: 'var(--text-light)',
                                    marginBottom: '4px'
                                }}>
                                    Connected to @{instagramStatus.username}
                                </div>
                                <div style={{
                                    fontSize: '14px',
                                    color: 'rgba(245, 241, 237, 0.6)'
                                }}>
                                    Your Instagram account is successfully linked
                                </div>
                            </div>
                        </div>

                        {/* Stats Grid */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                            gap: '20px',
                            marginBottom: '30px'
                        }}>
                            <div style={{
                                padding: '20px',
                                background: 'rgba(255, 255, 255, 0.03)',
                                borderRadius: '12px',
                                border: '1px solid rgba(201, 169, 110, 0.2)'
                            }}>
                                <div style={{
                                    fontSize: '14px',
                                    color: 'rgba(245, 241, 237, 0.6)',
                                    marginBottom: '8px'
                                }}>
                                    Total Posts
                                </div>
                                <div style={{
                                    fontSize: '28px',
                                    fontWeight: '600',
                                    color: 'var(--accent-color)'
                                }}>
                                    {instagramStatus.postsCount || 0}
                                </div>
                            </div>

                            <div style={{
                                padding: '20px',
                                background: 'rgba(255, 255, 255, 0.03)',
                                borderRadius: '12px',
                                border: '1px solid rgba(201, 169, 110, 0.2)'
                            }}>
                                <div style={{
                                    fontSize: '14px',
                                    color: 'rgba(245, 241, 237, 0.6)',
                                    marginBottom: '8px'
                                }}>
                                    Last Synced
                                </div>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    color: 'var(--text-light)'
                                }}>
                                    {new Date(instagramStatus.lastSynced).toLocaleString()}
                                </div>
                            </div>
                        </div>

                        {/* Sync Button */}
                        <button
                            onClick={handleSyncInstagram}
                            disabled={syncing}
                            style={{
                                padding: '14px 32px',
                                background: syncing ? 'rgba(201, 169, 110, 0.3)' : 'linear-gradient(135deg, var(--accent-color) 0%, #B8935D 100%)',
                                border: 'none',
                                borderRadius: '10px',
                                color: '#000',
                                fontSize: '15px',
                                fontWeight: '600',
                                cursor: syncing ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}
                            onMouseEnter={(e) => {
                                if (!syncing) {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 8px 25px rgba(201, 169, 110, 0.4)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = 'none';
                            }}
                        >
                            {syncing ? (
                                <>⏳ Syncing...</>
                            ) : (
                                <>🔄 Sync Instagram Posts</>
                            )}
                        </button>
                    </div>
                ) : (
                    <div style={{
                        background: 'linear-gradient(135deg, rgba(201, 169, 110, 0.08) 0%, rgba(201, 169, 110, 0.03) 100%)',
                        border: '1px solid rgba(201, 169, 110, 0.2)',
                        borderRadius: '16px',
                        padding: '40px',
                        marginBottom: '30px'
                    }}>
                        {/* Not Connected Status */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            marginBottom: '30px',
                            padding: '20px',
                            background: 'rgba(255, 193, 7, 0.1)',
                            border: '1px solid rgba(255, 193, 7, 0.3)',
                            borderRadius: '12px'
                        }}>
                            <div style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #833AB4 0%, #FD1D1D 50%, #FCAF45 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '24px'
                            }}>
                                📸
                            </div>
                            <div style={{ flex: 1 }}>
                                <div style={{
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: 'var(--text-light)',
                                    marginBottom: '4px'
                                }}>
                                    Instagram Not Connected
                                </div>
                                <div style={{
                                    fontSize: '14px',
                                    color: 'rgba(245, 241, 237, 0.6)'
                                }}>
                                    Link your Instagram account to display posts on your website
                                </div>
                            </div>
                        </div>

                        {/* Link Form */}
                        <div>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontSize: '14px',
                                fontWeight: '500',
                                color: 'var(--text-light)'
                            }}>
                                Instagram Access Token *
                            </label>
                            <input
                                type="text"
                                value={accessToken}
                                onChange={(e) => setAccessToken(e.target.value)}
                                placeholder="Enter your Instagram Graph API access token"
                                style={{
                                    width: '100%',
                                    padding: '14px 18px',
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(201, 169, 110, 0.2)',
                                    borderRadius: '10px',
                                    color: 'var(--text-light)',
                                    fontSize: '15px',
                                    outline: 'none',
                                    transition: 'all 0.3s ease',
                                    marginBottom: '20px'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = 'var(--accent-color)';
                                    e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = 'rgba(201, 169, 110, 0.2)';
                                    e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                                }}
                            />

                            <button
                                onClick={handleLinkInstagram}
                                disabled={loading}
                                style={{
                                    padding: '14px 32px',
                                    background: loading ? 'rgba(201, 169, 110, 0.3)' : 'linear-gradient(135deg, var(--accent-color) 0%, #B8935D 100%)',
                                    border: 'none',
                                    borderRadius: '10px',
                                    color: '#000',
                                    fontSize: '15px',
                                    fontWeight: '600',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.3s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}
                                onMouseEnter={(e) => {
                                    if (!loading) {
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 8px 25px rgba(201, 169, 110, 0.4)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = 'none';
                                }}
                            >
                                {loading ? (
                                    <>⏳ Linking...</>
                                ) : (
                                    <>🔗 Link Instagram Account</>
                                )}
                            </button>
                        </div>
                    </div>
                )}

                {/* Instructions Card */}
                <div style={{
                    background: 'linear-gradient(135deg, rgba(201, 169, 110, 0.08) 0%, rgba(201, 169, 110, 0.03) 100%)',
                    border: '1px solid rgba(201, 169, 110, 0.2)',
                    borderRadius: '16px',
                    padding: '30px'
                }}>
                    <h3 style={{
                        fontSize: '20px',
                        fontWeight: '500',
                        color: 'var(--text-light)',
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <span style={{ fontSize: '24px' }}>📖</span>
                        How to Get Your Access Token
                    </h3>

                    <div style={{ fontSize: '14px', color: 'rgba(245, 241, 237, 0.7)', lineHeight: '1.8' }}>
                        <ol style={{ paddingLeft: '20px', marginBottom: '20px' }}>
                            <li style={{ marginBottom: '12px' }}>
                                Visit the <a 
                                    href="https://developers.facebook.com/apps" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ 
                                        color: 'var(--accent-color)',
                                        textDecoration: 'none',
                                        fontWeight: '500'
                                    }}
                                >
                                    Facebook Developers
                                </a> page and create a new app
                            </li>
                            <li style={{ marginBottom: '12px' }}>
                                Add the Instagram Basic Display product to your app
                            </li>
                            <li style={{ marginBottom: '12px' }}>
                                Configure your Instagram App settings and add test users
                            </li>
                            <li style={{ marginBottom: '12px' }}>
                                Generate a user access token from the Basic Display section
                            </li>
                            <li style={{ marginBottom: '12px' }}>
                                Copy the access token and paste it above to link your account
                            </li>
                        </ol>

                        <div style={{
                            padding: '16px',
                            background: 'rgba(23, 162, 184, 0.1)',
                            border: '1px solid rgba(23, 162, 184, 0.3)',
                            borderRadius: '8px',
                            marginTop: '20px'
                        }}>
                            <strong style={{ color: 'var(--text-light)' }}>📌 Note:</strong> Access tokens expire periodically. 
                            Make sure to refresh your token or enable long-lived tokens for uninterrupted service.
                        </div>

                        <div style={{ marginTop: '20px' }}>
                            <a 
                                href="https://developers.facebook.com/docs/instagram-basic-display-api/getting-started" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '10px 20px',
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(201, 169, 110, 0.3)',
                                    borderRadius: '8px',
                                    color: 'var(--accent-color)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                                    e.target.style.borderColor = 'var(--accent-color)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                                    e.target.style.borderColor = 'rgba(201, 169, 110, 0.3)';
                                }}
                            >
                                📚 Read Full Documentation →
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default AdminInstagram;

